import { request } from '@luna/api';
import { getEnv } from '@luna/env';
import { createQueryString } from '@luna/router';
import { deepClean } from '@luna/utils';
import { logger } from '@luna/logger';
import type { SortingCriteria } from '@api-client/export-center';

import type { ExportFileMetadataResponse } from '../types';
import type { ExportFilesFilterParams } from './ExportFilesFilterParams';
import { buildExportDateParams } from './buildExportDateParams';

const DEFAULT_PAGE_SIZE = 20;
const DEFAULT_SORT: SortingCriteria = 'CREATION_DATE_DESC';

type SearchArgs = ExportFilesFilterParams & {
    pageSize?: number;
    page?: number;
};

export async function fetchMetadataExportFiles({
    pageSize = DEFAULT_PAGE_SIZE,
    page = 0,
    sort = DEFAULT_SORT,
    startDate,
    endDate,
    createdFrom,
    createdTo,
    ...filterParams
}: SearchArgs): Promise<ExportFileMetadataResponse> {
    const dateParams = buildExportDateParams({ startDate, endDate, createdFrom, createdTo });

    const urlParams: SearchArgs = {
        page,
        pageSize,
        sort,
        ...filterParams,
        ...dateParams,
    };

    const queryString = createQueryString(deepClean(urlParams));
    const url = `${getEnv().apiGatewayUrl}export-center/public/metadata${queryString}`;

    return request<ExportFileMetadataResponse>(url).catch((error) => {
        logger.error('Export Center :: Files metadata loading failed', error);
        throw error;
    });
}
